import {
  FEEDBACK_MESSAGE_SHOW,
  FEEDBACK_MESSAGE_HIDE
} from 'src/app/redux/actions/feedbackMessage';


const initialState = {
  template: '',
  icon: '',
  description: ''
};

const feedbackMessageReducer = (state = initialState, action) => ({
  [FEEDBACK_MESSAGE_SHOW]: () => ({ ...state, ...action.payload }),
  [FEEDBACK_MESSAGE_HIDE]: () => ({ ...state, template: '', icon: '', description: '' })
}[action.type] || (() => state))();

export default feedbackMessageReducer;
